import React, { Component } from 'react';
import { connect } from 'react-redux';

import bca from "../../assets/images/bca.png";
import bri from "../../assets/images/bri.png";
import danamon from "../../assets/images/danamon.png";
import mandiri from "../../assets/images/mandiri.png";
import indomaret from "../../assets/images/indomaret.png";
import bni from "../../assets/images/bni.png";
import mastercard from "../../assets/images/mastercard.png";
import visa from "../../assets/images/visa.png";
import jcb from "../../assets/images/jcb.png";
import moment from 'moment';
import { Link } from 'react-router'
import { updateQuery } from '../../actions/search.js';
import Trans from '../../locale/Translate.js'

class Footer extends Component {
	render() {
		const agentData = JSON.parse(localStorage.getItem('agentData')) || { user: {} };
		const homePhone = agentData.data && agentData.data.company_telephone ? agentData.data.company_telephone : '';
		const email = agentData.data && agentData.data.company_email ? agentData.data.company_email : '';
		const companyName = agentData.data && agentData.data.company_name ? agentData.data.company_name : '';

		return (
			<footer className="footer">
				<div className="container-fluid">
					<div className="footer-content">
						<div className="footer-section">
							<h4>{Trans.data.contact_us}</h4>
							<ul>
								<li><i className="fa fa-phone"></i> {homePhone}</li>
								<li><i className="fa fa-envelope-o"></i> {email}</li>
							</ul>
						</div>
						<div className="footer-section">
							<h4>{Trans.data.help}</h4>
							<ul>
								<li><Link to="/about-us">About Us</Link></li>
								<li><Link to="/privacy-policy">{Trans.data.privacy_policy}</Link></li>
								<li><Link to="/term">{Trans.data.term_condition}</Link></li>
							</ul>
						</div>
					</div>
					<div className="footer-copyright">
						<p>Copyright {new Date().getFullYear()}. All rights reserved</p>
					</div>
				</div>
			</footer>
		)
	}
}

const mapStateToProps = state => {
	const { isLoggedIn } = state.authReducer
	return {
		isLoggedIn
	}
}

export default connect(mapStateToProps)(Footer)
